import styled from 'styled-components';
import { rem } from '@/styles/theme';
import { ReactNode } from 'react';

interface IProps {
  children: ReactNode;
}

const Container = styled.div`
  // max-width: ${rem(414)};
  // margin: 0 auto;
  background-color: #ffffff;
  //padding: ${rem(20)} 0;
`;

const DefaultLayout = (props: IProps) => {
  const { children } = props;

  return (
    <Container>
      <main>{children}</main>
    </Container>
  );
};

export default DefaultLayout;
